module.exports = __webpack_public_path__ + "static/media/asc-star.b7c59f05.svg";